module.exports = __webpack_public_path__ + "e4.no2.db976e30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/e4.no2.jpg
// module id = AfFL
// module chunks = 0